import * as Immutable from 'immutable';
import {
  GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_ABORTED,
  GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED,
  GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED,
  GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_FAILED,
  // RESET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED,
  // RESET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED,
} from '../../actions/plancontributionsandwithdrawals/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_PLAN_CONTRIBUTIONSANDWITHDRAWALS_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
